import { DateTime } from "luxon";
import { getDateValueType } from "./getDateValueType.function";

/**
 * Returns the valid end time (HH:mm) for the time picker when end date is selected.
 * - When max date has no time set or bookingTo is not the max date: 23:59.
 * - When today is the max date and max time is already past: 23:59 (so user can pick standard end time).
 * - Otherwise: max date's time.
 */
export function getValidEndTime(maxDate: string, bookingTo: string | null): string {
  if (!getDateValueType(maxDate, bookingTo)) return "23:59";

  const maxTime = DateTime.fromISO(maxDate).toFormat("HH:mm");
  const today = DateTime.local().toFormat("yyyy-MM-dd");
  const nowTime = DateTime.local().toFormat("HH:mm");

  if (bookingTo === today && nowTime > maxTime) return "23:59";
  return maxTime;
}
